import React, { Component } from "react";
import Modal from "@acadia-ui/modal";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";

const formEl = "missingFinancialsModal";

class MissingFinancialsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.missingFinancialsModal(this);
	}

	componentWillUnmount() {
		this.props.missingFinancialsModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
	};

	updateModalState = () => {
		!this.state.open ? Modal.show(formEl) : Modal.hide(formEl);
		this.setState({ open: !this.state.open });
	};

	render() {
		return (
			<Modal
				id={formEl}
				// passiveModal={true}
				className="missingFinancialsModal"
				heading="Send to Prisma"
				description="Please ensure all campaign financial settings are updated."
				// open={this.state.open}
				// iconDescription="Close"
				onRequestClose={() => {
					Modal.hide(formEl);
				}}
				onClick={() => {}}
			></Modal>
		);
	}
}

export default MissingFinancialsModal;
